<div class="conteudo-parceiro">
  <div class="opcoes">
    <div class="p-3">
      <div class="titulo">
        <span>Encaminhar para o Parceiro</span>
      </div>

      <div class="mt-5 mb-5">
        <app-botao-voltar></app-botao-voltar>
      </div>

      <div class="sub-titulo my-2">
        Selecione o Parceiro
      </div>

      <form [formGroup]="encaminhaParceiroForm" (submit)="doEncaminhar()">
        <div>
          <label>Parceiro</label>
          <select formControlName="parceiro">
            <option [ngValue]="null" selected>
              Selecionar
            </option>
            <option *ngFor="let parceiro of parceiros" [ngValue]="parceiro.codigo">
              {{parceiro.nome}}
            </option>
          </select>
        </div>
        <div class="d-flex justify-content-end">
          <button class="button-primary" [disabled]="!isButtonEnabled()" type="submit">
            {{labelBotao}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>